import { useState, useEffect, useCallback } from 'react';
import { getMyAlerts, markAlertRead } from '../lib/attendance';
import { visiblePoll } from '../lib/poll';
import { Glyph } from './Icons';

// Avisos para el empleado (por ejemplo: se registró una marcación suya desde otro dispositivo)
export default function UserAlerts() {
  const [alerts, setAlerts] = useState([]);
  const load = useCallback(async () => setAlerts(await getMyAlerts()), []);
  useEffect(() => { load(); return visiblePoll(load, 180000); }, [load]);
  if (!alerts.length) return null;
  return (
    <div className="space-y-2.5">
      {alerts.map((a) => (
        <div key={a.id} className={`rounded-3xl p-4 flex items-start gap-3 border ${a.type==='justification'?(a.data?.approved?'bg-emerald-50 border-emerald-200':'bg-amber-50 border-amber-200'):'bg-red-50 border-red-200'}`}>
          <span className="w-9 h-9 rounded-xl bg-red-100 text-red-600 flex items-center justify-center shrink-0"><Glyph name="device" className="w-5 h-5" /></span>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-bold text-red-800">{a.title}</p>
            {a.body && <p className="text-xs text-red-700/80 mt-0.5">{a.body}</p>}
            <button onClick={async () => { await markAlertRead(a.id); setAlerts((x) => x.filter((y) => y.id !== a.id)); }} className="mt-2 text-xs font-semibold text-red-700 underline">Entendido</button>
          </div>
        </div>
      ))}
    </div>
  );
}
